import React from "react";
import api from "../../services/api.js";
import {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import {useParams}  from 'react-router-dom';
import "./ListaAno.css";

function ListaAno(props){
  
    let [dados,setdados] = useState([])
    let [qtde,setQtde] = useState(0)
    const parametros = useParams(); 
        
    async function CarregaDocto()
    {
        const cnpj = localStorage.getItem("usuario");
        const resultado = await api.get('/lstData/ListaAno.php/?p=' + cnpj+'&t='+props.tipo);
        setdados(resultado.data)   
        setQtde(resultado.data[0].IdFtp) 
    }

    useEffect(()=>{
          CarregaDocto()
    },[]  );

   return<>

               { qtde === 0 ?
                    <div className="alert alert-primary mt-2" role="alert">
                            Nenhum item a ser exibido !
                    </div>
                  :    
                     

                              <div className="row">   
                                                  
                                                  { dados.map(function(dado){
                                                                 return  <div className="col-md-4">
                                                                                <div className="card">
                                                                                     <div className="card-header text-center">
                                                                                          <Link to={'/listadata/'+dado.TipoDoc+dado.Ano} > <i className="fas fa-calendar-day"></i>{dado.Ano}</Link>                                                                
                                                                                     </div>
                                                                                
                                                                                </div>
                                                                           </div>  })
               
                                                            }      
                                             </div> 

             }

</>

}

export default ListaAno;
